@import '../config/_helpers';
.addon-section{
    h3{
        margin-bottom: 20px;
    }

	.addon-classification-wrapper{
		display: flex;
		align-items: center;
		justify-content: flex-start;
		flex-wrap: wrap;
		gap: 5px;
		margin-bottom: 20px;

		@include at-breakpoint(0,$l){
			max-width: 200px;
		}

		.tooltip{
			flex: 0 0 100%;
			width: 100%;

		}
		.addon-classification{
			border-radius: 10px;
			padding: 5px 10px;
			border: 1px solid rgba(0,0,0,0.1);
			cursor: pointer;
			user-select: none;
			transition: .4s all ease-in-out;
			&.active{
				background: black;
				color: white;
			}
		}
	}

    .addons-wrapper{
		justify-content: space-between;
        .addon{
            cursor: pointer;
            user-select: none;

			&:last-child{
				margin-right: auto;
			}

            .addon-image{
                position: relative;
                border: 1px solid rgba(0,0,0,0.1);
                margin-bottom: 10px;
                user-select: none;
                border-radius: 10px;
				min-height: 150px;
                overflow: hidden;
                .addon-tooltip {
                    height: max-content;
                    margin: 0;
                    padding: 0;
                    display: flex;
                    align-items: flex-start;
                    position: absolute;
                    top: 5px;
                    right: 5px;
                    z-index: 5;
                    border: 0;

					svg {
						margin: 0;
						padding: 5px;
						border-radius: 50%;
					}

					.addon-tooltip-text {
						max-height: 0;
						max-width: 0;
						margin-block: 5px;
						overflow: hidden;
						background: inherit;
						color: white;
						transition:
							opacity 0.85s ease-in-out,
							ease-in-out,
							max-height 0.85s ease-in-out,
							max-width 0.85s ease-in-out;
						opacity: 0;

						&.active {
							max-height: 125px;
							max-width: 500px;
							opacity: 1;
						}

						p {
							padding-inline: 5px;
						}
					}
				}

				.addon-check-status {
					position: absolute;
					bottom: 0;
					left: 0;
					right: 0;
					background: #e8e8e8;
					text-align: center;
					padding: 5px;
					transition: background 0.4s ease-in-out;
					color: var(--emphasis-color);
					border-top: 1px solid rgba(0, 0, 0, 0.1);
					font-weight: bold;
					// backdrop-filter: blur(5px);

					&.checked {
						color: white;
						background: var(--emphasis-color);
					}
				}

				.addon-id {
					padding: 5px;
					position: absolute;
					top: 0;
					background-color: var(--contrast-color-light-5);
				}
			}
			.addon-info {
				.addon-price {
				}
			}
		}
	}
	.included-addons-wrapper {
		// background: rgba(0,0,0,0.1);
		border: 2px solid rgba(0, 0, 0, 0.1);
		padding: 20px;
		border-radius: 5px;
		margin-bottom: 10px;
		@include at-breakpoint(0, $l) {
			padding: 10px;
		}
		strong {
			border-bottom: 1px solid rgba(0, 0, 0, 0.1);
			padding-bottom: 5px;
		}
		.included-addon {
			background: white;
			border: 1px solid rgba(0, 0, 0, 0.1);
			// padding: 5px;
			border-radius: 5px;
			img {
				border-radius: 5px;
				max-width: 70px;
				border-right: 1px solid rgba(0, 0, 0, 0.1);
			}
			.addon-name {
				font-weight: bold;
			}
		}
	}

	.slider .slider-wrapper .slider-arrow-container{
		pointer-events: none;
		bottom: 100%;
		padding-bottom: 10px;
		width: fit-content;
		right: 0;

		@include at-breakpoint(0,$l){
			padding-bottom: 30px;
		}

		.slider-arrow{
			pointer-events: all;
			background: black;
			color: white;
			margin: 0;
		}
	}
}
